import { setError, logout } from '../actions/session';
import { Raven } from 'raven-js';
import fetch from 'cross-fetch';
import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { onError } from "@apollo/client/link/error";

// TODO get orgCode from packages/marketpay/src/js/store
const orgCode = window.location.pathname.split('/')[3];

const httpLink = new HttpLink({
  uri: `/services/o/${orgCode}/`,
  credentials: 'include',
  fetch: fetch
});

const logoutLink = onError(res => {
  // only worry about network errors with a bad status code and not general gql errors
  if (res.networkError) {
    console.log('graphql network error response status code: ', res.networkError.statusCode);
    if (typeof Raven !== 'undefined') Raven.captureException(res.networkError);
    if (res.networkError.statusCode === 401 || res.networkError.statusCode === 403) {
      window.__dispatchReduxStore(logout());
    } else if (res.networkError.statusCode === 400 || res.networkError.statusCode === 404) {
      // Ignore gql 400's and 404's for now until we get component specific logic error displays
      return;
    } else if (res.networkError.statusCode === 502 || res.networkError.statusCode === 504) {
      window.__dispatchReduxStore(setError(res.networkError.statusCode));
    } else {
      window.__dispatchReduxStore(setError());
    }
  }
});

export default new ApolloClient({
  link: from([logoutLink, httpLink]),
  cache: new InMemoryCache(),
  shouldBatch: true
});
